import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/$dealership/deal-packets/templates")({
  staticData: {
    breadcrumb: "Templates",
  },
  component: TemplatesLayout,
})

function TemplatesLayout() {
  return <Outlet />
}
